export default __webpack_public_path__ + "static/media/AdminLTELogo.a387505d.jpg";